export default __webpack_public_path__ + "static/Bremen-dcdad05d7140a44d1af38bf3e8ace745.png";